const Account = () =>
  import(/* webpackChunkName: "account" */ '@/pages/account/index.vue')
const EditAccount = () =>
  import(/* webpackChunkName: "account" */ '@/pages/account/edit.vue')
const ChangePassword = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/change-password.vue'
  )
const CreatePasswod = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/create-password.vue'
  )
const BankAccounts = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/bank-accounts/index.vue'
  )
const CommercialBanking = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/commercial-banking/index.vue'
  )
const CreateBankCredit = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/commercial-banking/create-bank-credit/index.vue'
  )
const WalletPage = () =>
  import(/* webpackChunkName: "account" */ '@/pages/account/wallet/index.vue')
// const MyPayments = () =>
//   import(
//     /* webpackChunkName: "account" */ '@/pages/account/my-payments/index.vue'
//   )
const BankAccountsAction = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/bank-accounts/action.vue'
  )
const Contracts = () =>
  import(/* webpackChunkName: "account" */ '@/pages/account/contract/index.vue')
const ActiveSessions = () =>
  import(
    /* webpackChunkName: "account" */ '@/pages/account/active-sessions.vue'
  )

export default {
  path: 'account',
  component: {
    name: 'AccountWrapper',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'Account',
      path: '',
      component: Account,
      meta: { title: 'nav.account' }
    },
    {
      name: 'EditAccount',
      path: 'edit',
      component: EditAccount,
      meta: { title: 'nav.editAccount' }
    },
    {
      name: 'ChangePassword',
      path: 'change-password',
      component: ChangePassword,
      meta: { title: 'nav.changePassword' }
    },
    {
      name: 'CreatePassword',
      path: 'create-password',
      component: CreatePasswod,
      meta: { title: 'nav.createPassword' }
    },
    {
      name: 'BankAccounts',
      path: 'bank-accounts',
      component: BankAccounts,
      meta: { title: 'nav.myBankAccounts' }
    },
    {
      name: 'CommercialBanking',
      path: 'commercial-banking',
      component: CommercialBanking,
      meta: { title: 'nav.commercialBanking' }
    },
    {
      name: 'Wallet',
      path: 'wallet',
      component: WalletPage,
      meta: { title: 'nav.wallet' }
    },
    {
      name: 'CreateBankCredit',
      path: 'create-bank-credit',
      component: CreateBankCredit,
      meta: { title: 'nav.CreateBankCredit' }
    },
    // {
    //   name: 'MyPayments',
    //   path: 'my-payments',
    //   component: MyPayments,
    //   meta: { title: 'nav.myPayments' }
    // },
    {
      name: 'BankAccountsAction',
      path: 'bank-accounts/:action',
      component: BankAccountsAction,
      meta: { title: 'nav.myBankAccounts' }
    },
    {
      name: 'Contracts',
      path: 'contracts',
      component: Contracts,
      meta: { title: 'nav.contract' }
    },
    {
      name: 'ActiveSessions',
      path: 'active-sessions',
      component: ActiveSessions,
      meta: { title: 'nav.activeSessions' }
    }
  ]
}
